// src/views/UserDynamicView.tsx

// 日志管理页面(普通用户)

// 第三方
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

// 自定义
import Header from './components/Header';
import UserSidebar from './components/UserSidebar';
import { DynamicContent } from './components/DynamicContent';
import { Global } from '../services/Global';
import { browserUtil } from '../utils/BrowserUtil';
import { Layout } from 'antd';
import { Page } from '../services/Page';

const { Content } = Layout;

class UserDynamicView extends React.Component<WithTranslation> {

    state = {
        loginName: '',
    }

    componentWillMount = () => {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount = () => {
    }

    changeLang = () => {
    }

    render() {
        const { t, i18n } = this.props
        return (
            <Layout className="body" style={{ minHeight: '100vh' }}>

                {/* 顶部 Header */}
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />

                <Layout>
                    {/* 侧边栏 */}
                    <UserSidebar selectMenu={Page.userDynamic} trans={t} />

                    {/* 主内容区 */}
                    <Content>
                        <DynamicContent />
                    </Content>
                </Layout>
            </Layout>
        )
    }

}
export const UserDynamicPage = withTranslation()(UserDynamicView)